export default __webpack_public_path__ + "static/media/hra_low.f547275e.svg";